<template>
  <div>
    <el-card>
    <div >
      <el-col :span="8">
        <el-input clearable size="small" :placeholder="$t('message.placeholder.input')" @clear="searchLists" @keyup.enter.native="searchLists" v-model="search" class="input-with-select" style="margin:0 20px 0 0">
          <el-button slot="append" icon="el-icon-search" @click="searchLists"></el-button>
        </el-input>
      </el-col>
      <el-button style="margin-left: 20px;" type="success" size="small" icon="el-icon-plus" @click="addNewCodeNum">{{$t('message.button.add')}}</el-button>
    </div>
    <div style="margin-top:20px">
      <vxe-grid ref='xGrid' v-bind="gridOptions" @cell-dblclick="dbClickRow" :row-style="{height:'56px'}">
        <template v-slot:operate="{ row }">
          <el-button :title="$t('message.button.delete')"  @click="removeCodeNum(row)" type="text" icon="el-icon-delete" >{{$t('message.button.delete')}}</el-button>
        </template>
        <template v-slot:is_enabled="{ row }">
          <el-switch v-model="row.enabled" @change="switchChange(row)" active-color="#13ce66"></el-switch>
        </template>        
      </vxe-grid>
    </div>
    </el-card>

    <el-dialog :close-on-click-modal="false" class="autoNum-edit" :title="editPageTitle" :visible.sync="pageListDataShow" @closed="dialogClose">
      <div style="height: 30px;">
        <el-button size="mini" style="float: right;margin-right: 10px;margin-top: 10px;" @click="resetPageInfo"
          >{{$t('message.button.reset')}}</el-button>
        <el-button v-if="addBtn_Show" type="success" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
          @click="saveNewCodeNum('ruleForm')">{{$t('message.button.add')}}</el-button>
        <el-button v-else type="success" size="mini" style="float: right;margin-right: 10px;margin-top: 10px;"
          @click="submitPageForm('ruleForm')">{{$t('message.button.save')}}</el-button>
      </div>

      <el-form ref="ruleForm" :model="codeNumber_edit" style="margin:20px 40px;" label-width="120px" size="small">
        <el-form-item :label= "$t('message.title.code')" required>
          <el-input  v-model="codeNumber_edit.code" :style="input_width" :disabled='!addAutoNum&&codeNumber_edit.enabled=="1"'></el-input>
        </el-form-item>

        <el-form-item :label= "$t('message.title.codeInstructions')" required>
          <el-input v-model="codeNumber_edit.name" :style="input_width" :disabled='!addAutoNum&&codeNumber_edit.enabled=="1"'></el-input>
        </el-form-item>

        <el-form-item :label= "$t('message.title.des')">
          <!-- <el-input type="textarea" v-model="codeNumber_edit.description" :style="input_width" :disabled='!addAutoNum&&codeNumber_edit.enabled=="1"'></el-input> -->
          <el-input type="textarea" v-model="codeNumber_edit.description" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.isEnabled')">
          <el-select @change="changeSelect" v-model="codeNumber_edit.enabled" :placeholder="$t('message.placeholder.select')" size="small" style="width:100%">
            <el-option :label="$t('message.table.yes')" value="1"></el-option>
            <el-option :label="$t('message.table.no')" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label= "$t('message.title.codeObject')" required>
          <el-select style="width:100%" v-model="codeNumber_edit.subclassId" :placeholder="$t('message.placeholder.select')" @change="selectSubclass" clearable :disabled='!addAutoNum&&codeNumber_edit.enabled=="1"'>
            <el-option-group
              v-for="group in options"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.used==1">
              </el-option>
            </el-option-group>
          </el-select>      
        </el-form-item>

        <el-form-item :label="$t('message.title.defineCodePro')">
          <el-dialog
            width="50%"
            :title="$t('message.placeholder.selectAttribute')"
            :visible.sync="selectAttributeVisible"
            append-to-body
            :close-on-click-modal="false"
          >
            <el-transfer
              v-model="selectedAttributes"
              :data="allAttributes"
              @change="selectAttributes"
              :titles=tableName
              target-order=push 
            >
            </el-transfer>
          </el-dialog>
          <ListData
            
            :listData="displaySelectedAttributes"
            @click="openSelectAttributeDialog"
            :style="input_width"
          ></ListData>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<style>
	.autoNum-edit .el-dialog__body {
    padding-top: 0 !important;
    padding-right: 20px;
  }
</style>
<style scoped>

</style>

<script>
import axios from "axios";
import ListData from "@/views/systerm/workflow/infoShow/listData.vue";
export default {
  name: 'CodeNumbers',
  data() {
    // const numberLength = (val) =>{
    //   if (val < this.codeNumber_edit.beginNumber.length) {
    //     return this.$message('111111')
    //   }
    // }
    return {
      search: "",
      allAttributes: [],
      selectedAttributes: [],
      optionalAttributes: [],
      displaySelectedAttributes: [],
      selectAttributeVisible: false,
      checked: [],
      transferData: [],
      tableName: [], //数据表名
      options:[],
      value:'',
      arr:[],
      input_width: {},
      editPageTitle:"",
      pageListDataShow:false,
      addAutoNum:false,
      gridOptions: {
        resizable: true,//列是否允许拖动列宽调整大小
        // border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "680",
        // size: "small",
        columns: [
          { 
          sortable: true,
          field: 'code', 
          width: '15%',
          title: this.$t('message.title.code')
          },
          { 
          sortable: true,
          field: 'name', 
          width: '20%',
          title: this.$t('message.table.name')
          },
          { 
          sortable: true,
          field: 'description',
          width: '35%', 
          title: this.$t('message.table.des')
          },
          { 
          sortable: true,
          field: 'enabled', 
          width: '15%',
          title: this.$t('message.table.isEnabled'),
          slots: {
              default: 'is_enabled'
          }
          },
          {
          title: this.$t('message.table.actions'),
          width: '15%',
          slots: {
              default: 'operate'
          }
        }],
        data: [],
        sortConfig: {
          trigger: 'cell'
        },
      },
      codeNumber_view:[],
      codeNumber_edit:{},
      codeNumber_edit_old:{},
      addBtn_Show:false,
      rules: {
        code: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        ],
        name: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        ],
        description: [
          { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        ],
        // type: [
        //   { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        // ],
        // attribute: [
        //   { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        // ],
        // beginNumber: [
        //   { required: true, message: this.$t('message.warning.required'), trigger: 'blur' }
        // ],
        // numberLength: [
        //   { required: true, message: this.$t('message.warning.required'), trigger: 'blur' },
        //   // { validator: numberLength, trigger: "blur" },
        //   // { min: 1, max: 1, message: '数字长度不得超过9', trigger: 'blur' }
        //   // { required: true, message: this.$t('message.warning.numberError'), trigger: 'blur' }
        // ],
        
      }
	  }
  },
 
	mounted(){
    this.getSubClass()
	},
  components:{
    ListData,
  },
  methods: {
    //将数组中attrId和attrName转化成key和label
    // turnArr(arr) {
    //   let data = arr.map((i) => {
    //     console.log(i);
    //     return {
    //       key: i.attrId,
    //       label: i.attrName,
    //     };
    //   });
    //   return data;
    // },

    changeSelect(){
      this.$forceUpdate();
    },
    switchChange(row){
      let vm = this;
      let obj = {
        code:row.code,
        description:row.description,
        enabled:row.enabled ? 1:0,
        id:row.id,
        name:row.name,
        subclassId:row.subclassId
      };
      axios.post('/pmdm/admin/updateAttrNumber', obj)
        .then((res) => {
          console.log(res);
          if(res.data.code == 200) {
            vm.$message({
              message: res.data.message,
              type: 'success'
            });
          }        
          vm.loadAllCodeNumbers();
        })
        .catch(function (error) {
          console.log(error);          
        });
    },
    searchLists(e) {
      if (!this.search || this.search == "*") {
        this.gridOptions.data = this.codeNumber_view;
        return;
      }else {
        let searchVal = [];
        console.log(e);
        this.codeNumber_view.forEach(item => {
          if (item.name.indexOf(this.search) !== -1) {
            searchVal.push(item);
          };
        });
        this.gridOptions.data = searchVal;
      };
    },
    selectSubclass(){
      
      console.log(this.codeNumber_edit.subclassId);
      if(this.codeNumber_edit.subclassId==""){
        console.log("selectSubclass");
        this.selectedAttributes = [];
        this.allAttributes = [];
        this.displaySelectedAttributes = [];
        return false;
      }
      var vm = this;
      axios.get('/pmdm/admin/getAttrListForAttrNumber?subClassId='+this.codeNumber_edit.subclassId)
      .then(function (res) {
        console.log(res);
        if (res.data.code == 200) {
          //vm.codeNumber_edit = vm.deepClone(res.data.object.autoNumber);

          vm.allAttributes = res.data.object.allAttrList.map((i) => {
            console.log(i);
            return {
              key: i.attrId,
              label: i.tableName+"."+i.attrName,
            };
          });
          console.log(vm.allAttributes);
          vm.selectedAttributes = [];
          vm.codeNumber_edit.attributeFields='';
          // vm.allAttributes = vm.optionalAttributes;
          vm.displaySelectedAttributes = [];
          // vm.codeNumber_edit.selectedAttributes = res.data.object.selectedAttrList;
          // let data = [];
          // data = res.data.object.attrNumber;
          // data.enabled = data.enabled+"";
          // console.log(data);
          // vm.codeNumber_edit = vm.deepClone(data);
          // vm.codeNumber_edit_old =vm.deepClone(data);
          // vm.editPageTitle = data.name;
        };
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    selectAttributes() {
      console.log(this.selectedAttributes);

      this.codeNumber_edit.attributeFields = this.selectedAttributes.join(";");
      this.displaySelectedAttributes = [];
      console.log(this.selectedAttributes.length);
      // console.log(this.codeNumber_edit.attributeFields);
      for(let i=0 ; i< this.selectedAttributes.length; i++ ){
        console.log(i);
        console.log(this.selectedAttributes[i]);
        for(let j=0 ; j< this.allAttributes.length; j++){
          if(this.allAttributes[j].key==this.selectedAttributes[i]){
            this.displaySelectedAttributes.push(this.allAttributes[j].label);
          };
        }
        // this.allAttributes.map((j)=>{return{
        //   if(j.key==this.selectedAttributes[i].key){
        //     this.displaySelectedAttributes.push(j.label);
        //   };
        // }});
        // console.log(i);
        // console.log(this.allAttributes[i]);
        // console.log(this.codeNumber_edit.attributeFields.indexOf(this.allAttributes[i].key));
        // if(this.codeNumber_edit.attributeFields.indexOf(this.allAttributes[i].key)>=0){
        //   this.displaySelectedAttributes.push(this.allAttributes[i].label);
        // }
      };
      // console.log(this.displaySelectedAttributes);
      // console.log(this.codeNumber_edit.attributeFields);
      console.log(this.allAttributes);
    },
    openSelectAttributeDialog(e) {
      // console.log(e);
      this.selectAttributeVisible = true;
    },
    getSubClass(){
      console.log(this.options);
      axios.get('/pmdm/admin/cls/getSubClsesForAttrNumber')
      .then(res =>{
        console.log(res);
        this.options = [];
        let classes = res.data.object.clses;
        for (let i = 0; i < classes.length; i++) {
          const e = classes[i];        
          let a = e.children.map(item =>{
            return {value:item.id,label:item.name,used:item.hasUsed}
          })
          this.options.push({label:e.name,options:a})
        }
      })
      console.log(this.options);
    },
    loadAllCodeNumbers() {
      var vm = this;
      this.input_width = this.Global.input_width;
      axios.get('/pmdm/attrNumber/getAttrNumberList')
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            var data = res.data.object.attrNumberList;
            vm.codeNumber_view = vm.deepClone(data);
            for(var i = 0; i < vm.codeNumber_view.length; i++) {
              if(vm.codeNumber_view[i].enabled == 1) {
                // vm.codeNumber_view[i].enabled = this.$t('message.table.yes')
                vm.codeNumber_view[i].enabled = true;
              } else {
                // vm.codeNumber_view[i].enabled =  this.$t('message.table.no')
                vm.codeNumber_view[i].enabled = false;
              }
            };
            vm.gridOptions.data = vm.codeNumber_view;
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    dbClickRow(rowData) {
      console.log(rowData);
      this.pageListDataShow = true;
      this.addBtn_Show = false;
      this.codeNumber_edit = {};
      var vm = this;
      axios.get('/pmdm/admin/getAttrNumberById?id='+rowData.row.id)
        .then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            //vm.codeNumber_edit = vm.deepClone(res.data.object.autoNumber);
            let data = [];
            data = res.data.object.attrNumber;
            data.enabled = data.enabled+"";
            console.log(data);
            vm.codeNumber_edit = vm.deepClone(data);
            vm.codeNumber_edit_old =vm.deepClone(data);
            vm.editPageTitle = data.name;
            console.log(res.data.object.attrNumber.attributeFields);

            vm.optionalAttributes = res.data.object.optionalAttrList.map((i) => {
              return {
                key: i.attrId,
                label: i.tableName+"."+i.attrName,
              };
            });
            vm.selectedAttributes = res.data.object.selectedAttrList.map((i) => i.attrId);
            vm.allAttributes = res.data.object.allAttrList.map((i) => {
              return {
                key: i.attrId,
                label: i.tableName+"."+i.attrName,
              };
            });
            vm.displaySelectedAttributes = res.data.object.selectedAttrList.map((item) => item.tableName+"."+item.attrName);
            console.log(vm.selectedAttributes);
            console.log(vm.optionalAttributes);
            console.log(vm.codeNumber_edit.enabled);
            console.log(vm.addAutoNum);
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    removeCodeNum(row) {
      console.log(row);
      // if(row.enabled=="Yes" || row.enabled=="是"){
      if(row.enabled=="Yes" || row.enabled=="是" || row.enabled){
        console.log("请先禁用");
        this.$message({
          type: 'info',
          message: this.$t('message.error.pleaseDisable')
        });
        return false;
      }
      this.$confirm(this.$t('message.confirm.deleteList'), this.$t('message.tips.tip'), {
        confirmButtonText: this.$t('message.button.affirm'),
        cancelButtonText: this.$t('message.button.cancel'),
        type: 'warning'
      }).then(() => {
        var vm = this;
        axios.post('/pmdm/admin/deleteAttrNumber?id=' + row.id)
          .then(function (res) {
            if (res.data.code == 200) {
              console.log(res);
              vm.$message({
                type: 'success',
                message: res.data.message
              });
              vm.loadAllCodeNumbers();
            };
          })
          .catch(function (error) {
            //console.log(error);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('message.tips.deleteCancel')
        });
      });
    },
    dialogClose() {
      this.addAutoNum = false;
      // this.$refs.ruleForm.resetFields()
    },
    resetPageInfo() {
      // if(this.addAutoNum){
      //   this.codeNumber_edit = {};
      //   this.displaySelectedAttributes = [];
      //   this.selectedAttributes = [];
      //   this.allAttributes = [];
      // }else{
        this.codeNumber_edit.code = "";
        this.codeNumber_edit.name = "";
        this.codeNumber_edit.description = "";
        this.codeNumber_edit.enabled = '0';
        this.codeNumber_edit.subclassId = "";
        this.displaySelectedAttributes = [];
        this.selectedAttributes = [];
        this.allAttributes = [];
      // }
      
      // this.codeNumber_edit = this.deepClone(this.codeNumber_edit_old);submitPageForm
    },
    submitPageForm(formName) {
      var vm = this;
      console.log(this.codeNumber_edit);
      console.log(this.codeNumber_edit_old);
      // var obj = this.contrastData(this.codeNumber_edit_old,this.codeNumber_edit);
      var obj = this.codeNumber_edit;
      console.log(obj);
      if(JSON.stringify(obj) == "{}") {
        // this.$message.error(this.MessageInfo.e_203);
        return false;
      };
      // obj.id = this.codeNumber_edit_old.id;
      if(JSON.stringify(obj) !=='{}') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post('/pmdm/admin/updateAttrNumber', this.codeNumber_edit)
            .then((res) => {
              console.log(res);
              if(res.data.code == 200) {
                vm.$message({
                  message: res.data.message,
                  type: 'success'
                });
                vm.pageListDataShow = false;
                vm.loadAllCodeNumbers();
                vm.getSubClass();
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          } else {
            console.log(this.$t('message.warning.required'));
            return false;
          }
        });
        
      } else {
        this.$message.error(this.$t('message.error.change'));
      }
    },
    addNewCodeNum() {
      this.addAutoNum = true;
      this.pageListDataShow = true;
      this.addBtn_Show = true;
      this.codeNumber_edit = {};
      this.codeNumber_edit.enabled = '0';
      this.codeNumber_edit_old = {};
      this.editPageTitle = this.$t('message.title.add');
      this.displaySelectedAttributes = [];
      this.selectedAttributes = [];
      this.allAttributes = [];
    },
    saveNewCodeNum(formName) {
      var vm = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = vm.codeNumber_edit;
          console.log(obj);
          axios.post('/pmdm/admin/saveAttrNumber', obj)
            .then(function (res) {
              console.log(res);
              if(res.data.code == 200) {
                vm.$message({
                  message: res.data.message,
                  type: 'success'
                });
                vm.pageListDataShow = false;
                vm.loadAllCodeNumbers();
                vm.getSubClass();
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log(this.$t('message.error.add'));
          return false;
        }
      });
    },
  },
  created() {
    this.tableName = [
      this.$t("message.transform.choices"),
      this.$t("message.transform.selected"),
    ]
    this.loadAllCodeNumbers();
  },
  
};
</script>